module.exports = __webpack_public_path__ + "img/WeaponHandling.861ad869.png";